// extracted by mini-css-extract-plugin
module.exports = {"light":"button-module--light--3CX2M","dark":"button-module--dark--2h8HD","outline":"button-module--outline--1sIo3"};